import React from 'react'
import './Switch.sass'

/**
 * iOS-style toggle switch.
 * @param {{
 *   checked?: boolean,
 *   onChange?: (next: boolean) => void,
 *   disabled?: boolean,
 *   ariaLabel?: string,
 *   title?: string,
 *   className?: string,
 * }} props
 */
function Switch({
  checked = false,
  onChange,
  disabled = false,
  ariaLabel,
  title,
  className = '',
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
      className={['Switch', checked ? 'Switch_on' : '', className].filter(Boolean).join(' ')}
      onClick={() => {
        if (disabled || typeof onChange !== 'function') return
        onChange(!checked)
      }}
    >
      <span className="Switch-Knob" />
    </button>
  )
}

export default Switch
